<!--定场人员-->
<template lang="pug">
    el-dialog(
        title="查看定场人员"
        class="el-dialog-custom"
        top="3vh"
        width="95%"
        :close-on-click-modal="false"
        :append-to-body="true"
        :visible.sync="vaisible"
        @close="closeDialog(false)"
    )
        el-card(shadow="never" style="margin-bottom: 20px;")
            div.container(style="width: 40%; justify-content: space-between;")
                div.el-form-item__label 场地名称:&nbsp;&nbsp;{{ placeDetail.name }}
                div.el-form-item__label 场地属性:&nbsp;&nbsp;{{ placeDetail.typeLabels }}
            div.el-form-item__label 可定场会员类型:&nbsp;&nbsp;{{ placeDetail.memberTypeLabels }}
        el-card(shadow="never")
            div.clearfix(slot="header")
                span.fontStyle 定场人员
            div.container
                div
                    el-button(type="primary" @click='refundOpr') 退款
                    el-button(type="primary" @click="exportMemberList") 名单导出
                div(style="margin-left: 20px;")
                    div.el-form-item__label 选择时间
                    el-date-picker(
                        type="date"
                        v-model="timeParams"
                        value-format="yyyy-MM-dd"
                        style="width: 200px;"
                        placeholder="选择日期"
                        @change="getReserveUserData"
                    )
            el-table(:data="tableData" style="width: 100%;" border @selection-change="selectionChangeHandle")
                el-table-column(type="selection" :selectable="selectableOpr" header-align="center" align="center" width="50")
                el-table-column(prop="memberName" header-align="center" align="center" label="姓名")
                el-table-column(prop="memberAccount" header-align="center" align="center" label="账号")
                el-table-column(prop="memberLevelLabel" header-align="center" align="center" label="会员类型")
                //- el-table-column(prop="placeOrderPurposeLabel" header-align="center" align="center" label="定场目的")
                el-table-column(prop="typeLabel" header-align="center" align="center" label="场地属性")
                el-table-column(prop="typeNumberLabel" header-align="center" align="center" label="场号")
                el-table-column(header-align="center" align="center" label="日期")
                    template(slot-scope="scope")
                        font 周{{ weekConvent[scope.row.week.toString()] }}({{ scope.row.orderDate }})
                el-table-column(header-align="center" align="center" label="时间段")
                    template(slot-scope="scope")
                        font {{ scope.row.startTime }} - {{ scope.row.endTime }}
                el-table-column(prop="statusLabel" header-align="center" align="center" label="状态")
                el-table-column(header-align="center" align="center" label="支付金额")
                    template(slot-scope="scope")
                        font ￥{{ parseFloat(scope.row.payAmount).toFixed(2) }}
                el-table-column(header-align="center" align="center" label="退款比例")
                    template(slot-scope="scope")
                        font {{ scope.row.refundPercent ? scope.row.refundPercent + "%" : "" }}
                el-table-column(header-align="center" align="center" label="退款金额")
                    template(slot-scope="scope")
                        font {{ scope.row.refundAmount ? "￥"+ parseFloat(scope.row.refundAmount).toFixed(2) : "" }}
            el-pagination(@size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 30]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper")
        span.dialog-footer(slot="footer")
            el-button(@click="closeDialog(false)") 返回

        el-dialog(
            title="退款"
            :visible.sync="refundVisible"
            :append-to-body="true"
            :modal-append-to-body="false"
        )
            el-form(:model="refundForm" ref="refundForm" style="padding: 30px;")
                el-row
                    el-col(:span="8")
                        div(style="float: right;")
                            el-radio(v-model.number="refundForm.refundFeeType" :label="1" border style="width: 150px;") 按比例退款
                    el-col(:span="16")
                        el-form-item(prop="refundScale" label="：" style="display: inherit;")
                            el-input-number(v-model="refundForm.refundScale" :min="0" :max="100" :disabled="refundForm.refundFeeType === 1 ? false : true")
                el-row
                    el-col(:span="8")
                        div(style="float: right;")
                            el-radio(v-model.number="refundForm.refundFeeType" :label="2" border style="width: 150px;") 按固定金额退款
                    el-col(:span="16")
                        el-form-item(prop="refundFee" label="：" style="display: inherit;")
                            el-input-number(v-model="refundForm.refundFee" :min="0" :max="refundFeeMax" :precision="2" :disabled="refundForm.refundFeeType === 2 ? false : true")
                el-row
                    el-input(v-model="refundForm.refundDesc" type="textarea" :rows="6" resize="none" placeholder="请输入退款原因")
            span.dialog-footer(slot="footer")
                el-button(type="primary" @click="confirmRefund") 确 定
                el-button(@click="refundVisible=false") 取 消
</template>

<script>
import table from './table.js'

export default {
    name: 'SpotCrew',
    props: {
        vaisible: {
            type: Boolean,
            default: false
        },
        placeId: {
            type: String
        }
    },
    data () {
        return {
            table: {
                columns: table.columns,
                data: null,
                size: 'mini',
                stripe: true,
                border: true
            },
            refundFeeMax: 0, // 退款最大限制
            refundForm: {
                placeOrderItemIds: [],
                refundDesc: '',
                refundFee: 0,
                refundFeeType: 1,
                refundScale: 0
            },
            refundVisible: false,
            tableData: [],
            timeParams: '',
            placeDetail: {},
            chooseUser: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            weekConvent: { '1': '一', '2': '二', '3': '三', '4': '四', '5': '五', '6': '六', '7': '日' }
        }
    },
    created () {
        this.getReserveUserData()
        this.getPlaceDetailData()
    },
    methods: {
        selectableOpr (row, index) {
            if (row.status === 2 && row.payAmount > 0) { // 已支付
                return true
            } else {
                return false
            }
        },
        // 每页数
        sizeChangeHandle (val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getReserveUserData()
        },
        // 当前页
        currentChangeHandle (val) {
            this.pageIndex = val
            this.getReserveUserData()
        },
        // 导出约场地定场人员列表(后端导出,目前前台导出)
        exportMemberList () {
            // let userIds = []
            // if (this.chooseUser && this.chooseUser.length > 1) {
            //     userIds = this.chooseUser.map(ele => {
            //         return ele.id
            //     })
            // } else {
            //    // 全部导出
            // }
            // this.$http({
            //     url: this.$http.adornUrl(`/bp-book-places/export-member-list`),
            //     method: 'post',
            //     params: this.$http.adornParams({ ids: userIds })
            // })
            // 根据条件获取全部数据(前端导出)
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/member-list/${this.placeId}`),
                method: 'post',
                params: this.$http.adornParams({
                    bookPlaceId: this.placeId,
                    page: 1,
                    limit: 99999999
                }),
                data: { date: this.timeParams }
            })
            .then(data => {
                if (data && data.code === 0) {
                    if (!data.data || data.data.rows.length === 0) {
                        return this.$message.info('没有要导出的数据!')
                    }
                    // 前端导出逻辑
                    let exportData = data.data.rows
                    for (let i of exportData) {
                        i.payAmount = i.payAmount ? '¥' + i.payAmount + '元' : '' // 支付金额
                        i.refundPercent = i.refundPercent ? i.refundPercent + '%' : '' // 退款比例
                        i.refundAmount = i.refundAmount ? '¥' + i.refundAmount + '元' : '' // 退款金额
                        i.dateRange = i.startTime + '-' + i.endTime // 时间段
                        i.dateTime = '周' + this.weekConvent[i.week.toString()] + '(' + i.orderDate + ')'// 日期
                    }
                    this.$export.excel({
                        columns: this.table.columns,
                        data: exportData,
                        title: '定场地人员名单'
                    })
                    .then(() => {
                        this.$message.success('导出表格成功')
                    })
                }
            })
        },
        // 退款
        refundOpr () {
            if (this.chooseUser && this.chooseUser.length === 0) {
                return this.$message.error('请先选择定场人员')
            }
            this.refundVisible = true
            //退款金额赋最小值
            this.refundFeeMax = this.chooseUser[0].payAmount
            this.chooseUser.map(ele => {
                if (this.refundFeeMax > parseFloat(ele.payAmount.toFixed(2))) {
                    this.refundFeeMax = parseFloat(ele.payAmount.toFixed(2))
                }
            })
        },
        // 退款
        confirmRefund () {
            if (this.refundForm.refundFeeType === 1 && !this.refundForm.refundScale) {
                return this.$message.warning('退款比例设置不正确')
            }
            if (this.refundForm.refundFeeType === 2 && !this.refundForm.refundFee) {
                return this.$message.warning('退款金额设置不正确')
            }
            if (!this.refundForm.refundDesc) {
                return this.$message.warning('退款原因不可为空')
            }
            this.refundForm.placeOrderItemIds = this.chooseUser.map(ele => {
                return ele.id
            })
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/refund`),
                method: 'post',
                data: this.refundForm
            })
            .then(data => {
                if (data && data.code === 0) {
                    const { msg } = data
                    this.$message.success(msg)
                    this.getReserveUserData()
                    this.refundVisible = false
                }
            })
        },
        //勾选列表事件
        selectionChangeHandle (val) {
            this.chooseUser = val
        },
        // 获取场地详情接口
        getPlaceDetailData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/${this.placeId}`),
                method: 'get',
                params: this.$http.adornParams({ id: this.placeId })
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.placeDetail = data.data
                } else {
                    this.placeDetail = {}
                }
            })
        },
        // 获取定场人员数据
        getReserveUserData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/member-list/${this.placeId}`),
                method: 'post',
                params: this.$http.adornParams({
                    bookPlaceId: this.placeId,
                    page: this.pageIndex,
                    limit: this.pageSize
                }),
                data: { date: this.timeParams }
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.tableData = data.data.rows
                    this.totalPage = data.data.total
                } else {
                    this.tableData = []
                    this.totalPage = 0
                }
            })
        },
        closeDialog (val) {
            this.$emit('update:vaisible', val)
        }
    }
}
</script>

<style scoped>
.el-dialog-custom {
    overflow: hidden !important;
}
.el-dialog-custom /deep/ .el-dialog__body {
    height: 73vh;
    overflow: auto;
}
.el-dialog-custom /deep/ .el-dialog__footer {
    border-top: 1px solid #E9E9E9;
}

.fontStyle {
    font-weight: bold;
    font-size:18px;
}

.container {
    margin-bottom: 20px;
    display: flex;
}
</style>
